<template>
  <div v-if="answerCopy">
    <p-button
      outline
      icon
      :type="getFavoriteButtonType()"
      @click.prevent.native="addToDashboard()"
      class="questions-list__question-button"
      v-tooltip="{
        content: getFavoriteButtonText(),
        placement: 'bottom-center',
        classes: ['warning'],
      }"
    >
      <i class="fas fa-star"></i>
    </p-button>
  </div>
</template>

<script>
import QuestionAnswerController from '@/controllers/QuestionAnswer/QuestionAnswerController';

export default {
  name: 'FavoriteButton',
  props: {
    answer: Object,
    question: Object,
    company: Object,
  },
  data() {
    return {
      answerCopy: null,
    };
  },
  mounted() {
    this.setData(this.answer);
  },
  methods: {
    getFavoriteButtonType() {
      return this.answerCopy.favorite ? 'warning' : 'primary';
    },
    getFavoriteButtonText() {
      return this.answerCopy.favorite ? 'Remove from Dashboard' : 'Add to your Dashboard';
    },
    setData(answer) {
      this.answerCopy = answer;
    },
    async addToDashboard() {
      this.answerCopy = Object.assign({}, this.answerCopy, { favorite: !this.answerCopy.favorite });
      try {
        await QuestionAnswerController.store({
          question_id: this.question.id,
          related_to: this.company.company_id,
          value: this.answerCopy.value,
          achieved_weight: this.answerCopy.achieved_weight,
          favorite: this.answerCopy.favorite,
        });
        this.$notify({
          type: 'success',
          title: 'Saved!',
        });
      } catch (error) {
        this.$notify({
          type: 'danger',
          title: 'Was not saved!',
        });
      }
    },
  },
};
</script>

<style scoped></style>
